import FileSaver from 'file-saver';

export const downloadJson = (name, data) => {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  FileSaver.saveAs(blob, `${name}.json`);
};

export const downloadFile = (results, name) => {
  const blob = new Blob([JSON.stringify(results, null, 2)], { type: 'application/json' });
  FileSaver.saveAs(blob, name);
};
